module.exports = __webpack_public_path__ + "static/media/arrowIconLeft.61319945.svg";